import { IconWrapper } from '../runtime';
export default IconWrapper('dbs-format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 25 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0.5 3.75C0.5 1.67893 2.17893 0 4.25 0H20.75C22.8211 0 24.5 1.67893 24.5 3.75V20.25C24.5 22.3211 22.8211 24 20.75 24H4.25C2.17893 24 0.5 22.3211 0.5 20.25V3.75Z",
      "fill": 'url(#' + props.id + 'bda64a1e' + ')'
    }
  }), h("path", {
    "attrs": {
      "opacity": "0.830364",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M10.5752 3.88379C10.5752 3.53505 10.9547 3.31885 11.2547 3.49672L17.946 7.4644C18.3105 7.68052 18.534 8.07285 18.534 8.49659V17.6529C18.534 18.0016 18.1544 18.2178 17.8545 18.0399L11.1632 14.0723C10.7987 13.8561 10.5752 13.4638 10.5752 13.0401L10.5752 3.88379Z",
      "fill": "#85ECEB"
    }
  }), h("mask", {
    "attrs": {
      "id": props.id + '12a7dc40',
      "maskUnits": "userSpaceOnUse",
      "x": "10",
      "y": "3",
      "width": "9",
      "height": "16"
    },
    "style": {
      maskType: 'luminance'
    }
  }, [h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M10.5752 3.88379C10.5752 3.53505 10.9547 3.31885 11.2547 3.49672L17.946 7.4644C18.3105 7.68052 18.534 8.07285 18.534 8.49659V17.6529C18.534 18.0016 18.1544 18.2178 17.8545 18.0399L11.1632 14.0723C10.7987 13.8561 10.5752 13.4638 10.5752 13.0401L10.5752 3.88379Z",
      "fill": "white"
    }
  })]), h("g", {
    "attrs": {
      "mask": 'url(#' + props.id + '12a7dc40' + ')'
    }
  }, [h("g", {
    "attrs": {
      "opacity": "0.185362",
      "filter": 'url(#' + props.id + 'f4fba83e' + ')'
    },
    "style": {
      mixBlendMode: 'multiply'
    }
  }, [h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M9.15381 4.25332C9.15381 3.99323 9.43755 3.83259 9.66056 3.96642L16.7742 8.23535C16.9254 8.32606 17.0178 8.48941 17.0178 8.66569V18.4204C17.0178 18.6805 16.7341 18.8411 16.5111 18.7073L9.39744 14.4384C9.24629 14.3476 9.15381 14.1843 9.15381 14.008L9.15381 4.25332Z",
      "fill": "#0CCFCC"
    }
  })])]), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M8.49072 5.21021C8.49072 4.86147 8.87027 4.64527 9.17024 4.82314L15.8615 8.79082C16.226 9.00694 16.4495 9.39926 16.4495 9.823V18.9793C16.4495 19.328 16.07 19.5442 15.77 19.3664L9.07868 15.3987C8.7142 15.1826 8.49072 14.7902 8.49072 14.3665L8.49072 5.21021Z",
      "fill": "#91F4F3"
    }
  }), h("mask", {
    "attrs": {
      "id": props.id + 'fc39e233',
      "maskUnits": "userSpaceOnUse",
      "x": "8",
      "y": "4",
      "width": "9",
      "height": "16"
    },
    "style": {
      maskType: 'luminance'
    }
  }, [h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M8.49072 5.21021C8.49072 4.86147 8.87027 4.64527 9.17024 4.82314L15.8615 8.79082C16.226 9.00694 16.4495 9.39926 16.4495 9.823V18.9793C16.4495 19.328 16.07 19.5442 15.77 19.3664L9.07868 15.3987C8.7142 15.1826 8.49072 14.7902 8.49072 14.3665L8.49072 5.21021Z",
      "fill": "white"
    }
  })]), h("g", {
    "attrs": {
      "mask": 'url(#' + props.id + 'fc39e233' + ')'
    }
  }, [h("g", {
    "attrs": {
      "opacity": "0.185362",
      "filter": 'url(#' + props.id + 'ed5c8681' + ')'
    },
    "style": {
      mixBlendMode: 'multiply'
    }
  }, [h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M7.35376 5.76552C7.35376 5.50622 7.63596 5.34547 7.859 5.47772L15.0666 9.75156C15.2191 9.84195 15.3125 10.006 15.3125 10.1833V19.9398C15.3125 20.1991 15.0303 20.3599 14.8073 20.2276L7.59966 15.9538C7.44723 15.8634 7.35376 15.6993 7.35376 15.5221L7.35376 5.76552Z",
      "fill": "#0CCFCC"
    }
  })])]), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M6.40625 6.34791C6.40625 5.99898 6.78616 5.78281 7.08612 5.96105L13.778 9.93736C14.142 10.1536 14.365 10.5456 14.365 10.969V20.1153C14.365 20.4642 13.9851 20.6804 13.6852 20.5022L6.99326 16.5258C6.62932 16.3096 6.40625 15.9176 6.40625 15.4942V6.34791Z",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M7.92212 9.96104C7.92212 9.94154 7.94381 9.92987 7.96008 9.94062C8.64625 10.3937 9.05909 11.161 9.05909 11.9832V15.5549C9.05909 15.5744 9.0374 15.5861 9.02112 15.5753C8.33496 15.1223 7.92212 14.355 7.92212 13.5327V9.96104ZM11.5225 14.3196C11.5225 14.3001 11.5443 14.2884 11.5606 14.2992C12.2468 14.7537 12.6595 15.522 12.6595 16.3451V17.5958C12.6595 17.6339 12.617 17.6567 12.5853 17.6357L11.6569 17.0207C11.573 16.9651 11.5225 16.8712 11.5225 16.7706V14.3196ZM9.85488 12.0249C9.83865 12.0142 9.81706 12.0258 9.81706 12.0453V15.6382C9.81706 15.7391 9.86784 15.8333 9.95219 15.8888L10.8484 16.4784C10.8938 16.5082 10.954 16.4757 10.954 16.4215V14.0636C10.954 13.2424 10.541 12.4762 9.85488 12.0249Z",
      "fill": "#41CFCE"
    }
  }), h("defs", [h("filter", {
    "attrs": {
      "id": props.id + 'f4fba83e',
      "x": "7.78955",
      "y": "2.55395",
      "width": "10.5925",
      "height": "17.5657",
      "filterUnits": "userSpaceOnUse",
      "color-interpolation-filters": "sRGB"
    }
  }, [h("feFlood", {
    "attrs": {
      "flood-opacity": "0",
      "result": "BackgroundImageFix"
    }
  }), h("feBlend", {
    "attrs": {
      "mode": "normal",
      "in": "SourceGraphic",
      "in2": "BackgroundImageFix",
      "result": "shape"
    }
  }), h("feGaussianBlur", {
    "attrs": {
      "stdDeviation": "0.68213",
      "result": "effect1_foregroundBlur_913_640"
    }
  })]), h("filter", {
    "attrs": {
      "id": props.id + 'ed5c8681',
      "x": "5.9895",
      "y": "4.06616",
      "width": "10.6873",
      "height": "17.573",
      "filterUnits": "userSpaceOnUse",
      "color-interpolation-filters": "sRGB"
    }
  }, [h("feFlood", {
    "attrs": {
      "flood-opacity": "0",
      "result": "BackgroundImageFix"
    }
  }), h("feBlend", {
    "attrs": {
      "mode": "normal",
      "in": "SourceGraphic",
      "in2": "BackgroundImageFix",
      "result": "shape"
    }
  }), h("feGaussianBlur", {
    "attrs": {
      "stdDeviation": "0.68213",
      "result": "effect1_foregroundBlur_913_640"
    }
  })]), h("linearGradient", {
    "attrs": {
      "id": props.id + 'bda64a1e',
      "x1": "0.5",
      "y1": "0",
      "x2": "24.5",
      "y2": "24",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "stop-color": "#25D9E6"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#00A78B"
    }
  })])])]);
});